import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { ButtonWithLoading } from './FormsyHelperComponent'
const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.negative.main} !important`,
    color: 'white !important',
  },
}))

export default (props) => {
  const classes = useStyle(props)
  return (
    <ButtonWithLoading
      className={clsx(classes.root)}
      CircularProp={{ className: clsx(classes.root) }}
      {...props}
    >
      {props.children}
    </ButtonWithLoading>
  )
}
